"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHfilterDistrictItems = void 0;
var Area_1 = require("@/pages/search/states/Area");
exports.defaultHfilterDistrictItems = [
    {
        name: 'Hong Kong Island',
        id: 1000,
        area: null,
        selected: false,
        location: null,
        expanded: true
    },
    {
        name: 'Kowloon',
        id: 2000,
        area: null,
        selected: false,
        location: null,
        expanded: false
    },
    {
        name: 'New Territories',
        id: 3000,
        area: null,
        selected: false,
        location: null,
        expanded: false
    },
    {
        name: 'Outlying Islands',
        id: 4000,
        area: null,
        selected: false,
        location: null,
        expanded: false
    },
    {
        name: 'Aberdeen / Ap Lei Chau',
        id: 1,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2483068,
            lng: 114.1524398,
        },
    },
    {
        name: 'Causeway Bay',
        id: 4,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2859787,
            lng: 114.1914919,
        },
    },
    {
        name: 'Central',
        id: 119,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2799907,
            lng: 114.1587983,
        },
    },
    {
        name: 'Chai Wan',
        id: 6,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2678103,
            lng: 114.2360778,
        },
    },
    {
        name: 'Chung Hom Kok',
        id: 7,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2183333,
            lng: 114.2048704,
        },
    },
    {
        name: 'Deep Water Bay',
        id: 99,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2495068,
            lng: 114.1840643,
        },
    },
    {
        name: 'Fortress Hill',
        id: 128,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.289382,
            lng: 114.194524,
        },
    },
    {
        name: 'Happy Valley',
        id: 10,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.268352,
            lng: 114.1865135,
        },
    },
    {
        name: "Jardine's Lookout",
        id: 127,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2666667,
            lng: 114.2,
        },
    },
    {
        name: 'Mid-levels Central',
        id: 14,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2838219,
            lng: 114.1551419,
        },
    },
    {
        name: 'Mid-levels East',
        id: 15,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2705749,
            lng: 114.1811381,
        },
    },
    {
        name: 'Mid-levels West',
        id: 17,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2811673,
            lng: 114.142449,
        },
    },
    {
        name: 'North Point',
        id: 18,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2884683,
            lng: 114.192803,
        },
    },
    {
        name: 'North Point Hill',
        id: 16,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2913187,
            lng: 114.196578,
        },
    },
    {
        name: 'Pokfulam',
        id: 19,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2679201,
            lng: 114.1290719,
        },
    },
    {
        name: 'Quarry Bay',
        id: 20,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2827206,
            lng: 114.2123009,
        },
    },
    {
        name: 'Repulse Bay',
        id: 22,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2345043,
            lng: 114.1952039,
        },
    },
    {
        name: 'Sai Ying Pun',
        id: 24,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2875634,
            lng: 114.1417059,
        },
    },
    {
        name: 'Shau Kei Wan',
        id: 25,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.278746,
            lng: 114.2286476,
        },
    },
    {
        name: 'Shek O',
        id: 26,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2334016,
            lng: 114.2420218,
        },
    },
    {
        name: 'Sheung Wan',
        id: 97,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2863943,
            lng: 114.1491375,
        },
    },
    {
        name: 'Shouson Hill',
        id: 27,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2471845,
            lng: 114.1810919,
        },
    },
    {
        name: 'South Bay',
        id: 111,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2345043,
            lng: 114.1952039,
        },
    },
    {
        name: 'Stanley',
        id: 30,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.220422,
            lng: 114.2126685,
        },
    },
    {
        name: 'Tai Hang',
        id: 125,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2751881,
            lng: 114.1937244,
        },
    },
    {
        name: 'Tai Tam',
        id: 32,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2567774,
            lng: 114.2106427,
        },
    },
    {
        name: 'The Peak',
        id: 34,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2758835,
            lng: 114.145532,
        },
    },
    {
        name: 'Tin Hau',
        id: 129,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2823972,
            lng: 114.1922382,
        },
    },
    {
        name: 'Wan Chai',
        id: 37,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.276022,
            lng: 114.1751471,
        },
    },
    {
        name: 'Western / Kennedy Town',
        id: 98,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2730219,
            lng: 114.1498806,
        },
    },
    {
        name: 'Wong Chuk Hang',
        id: 115,
        area: Area_1.Area.HONG_KONG_ISLAND,
        selected: false,
        location: {
            lat: 22.2459198,
            lng: 114.1664957,
        },
    },
    {
        name: 'Cheung Sha Wan',
        id: 39,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3358055,
            lng: 114.1494892,
        },
    },
    {
        name: 'Diamond Hill',
        id: 40,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.35,
            lng: 114.2,
        },
    },
    {
        name: 'Ho Man Tin',
        id: 41,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.318507,
            lng: 114.1755339,
        },
    },
    {
        name: 'Hung Hom',
        id: 42,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3055658,
            lng: 114.1887233,
        },
    },
    {
        name: 'Jordan',
        id: 43,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3048612,
            lng: 114.1692021,
        },
    },
    {
        name: 'Kai Tak',
        id: 124,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3246084,
            lng: 114.1990482,
        },
    },
    {
        name: 'Kowloon Bay',
        id: 45,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3080749,
            lng: 114.2018982,
        },
    },
    {
        name: 'Kowloon City',
        id: 46,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3232097,
            lng: 114.1855505,
        },
    },
    {
        name: 'Kowloon Station',
        id: 104,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.304306,
            lng: 114.161475,
        },
    },
    {
        name: 'Kowloon Tong',
        id: 47,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3369319,
            lng: 114.1763367,
        },
    },
    {
        name: 'Kwun Tong',
        id: 48,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3103686,
            lng: 114.2227035,
        },
    },
    {
        name: 'Lai Chi Kok',
        id: 49,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3377817,
            lng: 114.1359272,
        },
    },
    {
        name: 'Lam Tin',
        id: 50,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3080199,
            lng: 114.2375638,
        },
    },
    {
        name: 'Mong Kok',
        id: 52,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3203648,
            lng: 114.169773,
        },
    },
    {
        name: 'Olympic Station',
        id: 103,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.317771,
            lng: 114.16022,
        },
    },
    {
        name: 'Sham Shui Po',
        id: 57,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3285899,
            lng: 114.1602846,
        },
    },
    {
        name: 'Shek Kip Mei',
        id: 58,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3337786,
            lng: 114.1674019,
        },
    },
    {
        name: 'To Kwa Wan',
        id: 60,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3173373,
            lng: 114.1879691,
        },
    },
    {
        name: 'Tsim Sha Tsui',
        id: 61,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.2988123,
            lng: 114.1721746,
        },
    },
    {
        name: 'Wong Tai Sin',
        id: 64,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3429615,
            lng: 114.1929813,
        },
    },
    {
        name: 'Yau Ma Tei',
        id: 65,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.3068537,
            lng: 114.1714423,
        },
    },
    {
        name: 'Yau Tong',
        id: 66,
        area: Area_1.Area.KOWLOON,
        selected: false,
        location: {
            lat: 22.2940736,
            lng: 114.2375638,
        },
    },
    {
        name: 'Clearwater Bay',
        id: 68,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.2851406,
            lng: 114.2940282,
        },
    },
    {
        name: 'Fanling',
        id: 70,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.4916829,
            lng: 114.1414685,
        },
    },
    {
        name: 'Kwai Chung',
        id: 74,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.3668502,
            lng: 114.1302591,
        },
    },
    {
        name: 'Ma On Shan',
        id: 75,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.4276756,
            lng: 114.2402751,
        },
    },
    {
        name: 'Sai Kung',
        id: 77,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.383689,
            lng: 114.2707867,
        },
    },
    {
        name: 'Sham Tseng',
        id: 79,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.367102,
            lng: 114.058809,
        },
    },
    {
        name: 'Shatin',
        id: 80,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.3771304,
            lng: 114.1974398,
        },
    },
    {
        name: 'Sheung Shui',
        id: 81,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.5112008,
            lng: 114.1260991,
        },
    },
    {
        name: 'Tai Po',
        id: 82,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.4423218,
            lng: 114.1655064,
        },
    },
    {
        name: 'Tseung Kwan O / Hang Hau',
        id: 73,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.3119259,
            lng: 114.2639618,
        },
    },
    {
        name: 'Tsing Yi',
        id: 84,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.3474872,
            lng: 114.1023164,
        },
    },
    {
        name: 'Tsuen Wan',
        id: 85,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.3699122,
            lng: 114.1144306,
        },
    },
    {
        name: 'Tuen Mun',
        id: 86,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.3908295,
            lng: 113.9725126,
        },
    },
    {
        name: 'Yuen Long',
        id: 87,
        area: Area_1.Area.NEW_TERRITORIES,
        selected: false,
        location: {
            lat: 22.4445376,
            lng: 114.0222076,
        },
    },
    {
        name: 'Cheung Chau',
        id: 88,
        area: Area_1.Area.OUTLYING_ISLANDS,
        selected: false,
        location: {
            lat: 22.2016179,
            lng: 114.0265007,
        },
    },
    {
        name: 'Discovery Bay',
        id: 89,
        area: Area_1.Area.OUTLYING_ISLANDS,
        selected: false,
        location: {
            lat: 22.2921406,
            lng: 114.0101467,
        },
    },
    {
        name: 'Lamma Island',
        id: 90,
        area: Area_1.Area.OUTLYING_ISLANDS,
        selected: false,
        location: {
            lat: 22.2000056,
            lng: 114.1350173,
        },
    },
    {
        name: 'Lantau Island',
        id: 91,
        area: Area_1.Area.OUTLYING_ISLANDS,
        selected: false,
        location: {
            lat: 22.2664984,
            lng: 113.941751,
        },
    },
    {
        name: 'Ma Wan',
        id: 92,
        area: Area_1.Area.OUTLYING_ISLANDS,
        selected: false,
        location: {
            lat: 22.3500753,
            lng: 114.059207,
        },
    },
    {
        name: 'Peng Chau',
        id: 93,
        area: Area_1.Area.OUTLYING_ISLANDS,
        selected: false,
        location: {
            lat: 22.2830679,
            lng: 114.0413675,
        },
    },
];
